export const TAX_EXPENSE_RECEIPT_ILLUSTRATION =
  require("../../../assets/images/tax-expense-receipt.png") as number;
